module.exports = __webpack_public_path__ + "media/Video 47.1c0e316c.mp4";